import React from 'react';
import { DatabaseIcon, MailIcon, PhoneIcon, CheckCircleIcon } from 'lucide-react';
export function OwnerFinderPricing() {
  return <section className="py-24 bg-slate-50" data-id="element-5996">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-5997">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-5998">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6 leading-tight" data-id="element-5999">
            Simple pricing to find{' '}
            <span className="text-blue-600" data-id="element-6000">business owner</span> contacts
          </h2>
          <p className="text-xl text-slate-600 leading-relaxed" data-id="element-6001">
            Find local business owners without enterprise contracts or hidden
            fees.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-6002">
          {/* Search Owners */}
          <div className="bg-white border border-slate-200 rounded-xl p-8 flex flex-col" data-id="element-6003">
            <div className="flex items-center gap-3 mb-4" data-id="element-6004">
              <DatabaseIcon className="w-5 h-5 text-slate-400" data-id="element-6005" />
              <h3 className="text-lg font-bold text-slate-900" data-id="element-6006">
                Search local business owners
              </h3>
            </div>
            <p className="text-slate-600 mb-8 flex-grow" data-id="element-6007">
              Search and filter local business owner records by industry and
              location.
            </p>
            <div data-id="element-6008">
              <div className="flex items-baseline gap-2" data-id="element-6009">
                <span className="text-4xl font-bold text-slate-900" data-id="element-6010">Free</span>
              </div>
              <p className="text-sm text-slate-500 mt-1" data-id="element-6011">unlimited searches</p>
            </div>
          </div>

          {/* Owner Emails */}
          <div className="bg-white border border-slate-200 rounded-xl p-8 flex flex-col" data-id="element-6012">
            <div className="flex items-center gap-3 mb-4" data-id="element-6013">
              <MailIcon className="w-5 h-5 text-slate-400" data-id="element-6014" />
              <h3 className="text-lg font-bold text-slate-900" data-id="element-6015">
                Local business owner emails
              </h3>
            </div>
            <p className="text-slate-600 mb-8 flex-grow" data-id="element-6016">
              Get verified email addresses for local business owners and
              decision-makers.
            </p>
            <div data-id="element-6017">
              <div className="flex items-baseline gap-2" data-id="element-6018">
                <span className="text-4xl font-bold text-slate-900" data-id="element-6019">$6</span>
              </div>
              <p className="text-sm text-slate-500 mt-1" data-id="element-6020">
                per 100 emails found
              </p>
            </div>
          </div>

          {/* Employee Phones */}
          <div className="bg-white border border-slate-200 rounded-xl p-8 flex flex-col" data-id="element-6021">
            <div className="flex items-center gap-3 mb-4" data-id="element-6022">
              <PhoneIcon className="w-5 h-5 text-slate-400" data-id="element-6023" />
              <h3 className="text-lg font-bold text-slate-900" data-id="element-6024">
                Business owner direct phones
              </h3>
            </div>
            <p className="text-slate-600 mb-8 flex-grow" data-id="element-6025">
              Access direct dial and mobile numbers for business owner contacts.
            </p>
            <div data-id="element-6026">
              <div className="flex items-baseline gap-2" data-id="element-6027">
                <span className="text-4xl font-bold text-slate-900" data-id="element-6028">$24</span>
              </div>
              <p className="text-sm text-slate-500 mt-1" data-id="element-6029">
                per 100 phones found
              </p>
            </div>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 sm:gap-12 mb-16" data-id="element-6030">
          <div className="flex items-center gap-2 text-slate-600 font-medium" data-id="element-6031">
            <CheckCircleIcon className="w-5 h-5 text-slate-400" data-id="element-6032" />
            <span data-id="element-6033">Pay only for valid results</span>
          </div>
          <div className="flex items-center gap-2 text-slate-600 font-medium" data-id="element-6034">
            <CheckCircleIcon className="w-5 h-5 text-slate-400" data-id="element-6035" />
            <span data-id="element-6036">Free credits to start</span>
          </div>
          <div className="flex items-center gap-2 text-slate-600 font-medium" data-id="element-6037">
            <CheckCircleIcon className="w-5 h-5 text-slate-400" data-id="element-6038" />
            <span data-id="element-6039">No credit card required</span>
          </div>
        </div>

        <div className="text-center" data-id="element-6040">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-4" data-id="element-6041">
            <a href="http://app.openmart.com/register" target="_blank" rel="noopener noreferrer" className="inline-block px-10 py-4 text-white font-bold bg-blue-600 rounded-lg hover:bg-blue-700 transition-colors text-lg" data-id="element-6042">
              Try for free
            </a>
          </div>
        </div>
      </div>
    </section>;
}